import type { ConversationReview } from "@common/domain/conversation-results";

// Reviews of a file opened locally (no backend) are kept in this browser's localStorage,
// keyed by the file's contents so reopening the same file, even renamed, restores them.
// ponytail: per-browser only; reviewers share them through Export report.
const PREFIX = "conversation-results:reviews:";

/** FNV-1a hash of the file text plus its length: stable across renames, changes when the contents change. */
export function contentKey(text: string): string {
  let h = 2166136261;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return `${h.toString(16).padStart(8, "0")}-${text.length}`;
}

export function loadLocalReviews(key: string): ConversationReview[] {
  try {
    const parsed = JSON.parse(localStorage.getItem(PREFIX + key) || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** Returns false when the browser refuses storage (private mode, quota, blocked site data). */
export function saveLocalReviews(key: string, reviews: ConversationReview[]): boolean {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(reviews));
    return true;
  } catch {
    return false;
  }
}
